import client from './client';

export async function uploadDocument(candidateId, formData) {
  const { data } = await client.post(`/candidates/${candidateId}/documents`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data.data;
}

export async function downloadDocument(id) {
  const response = await client.get(`/documents/${id}/download`, { responseType: 'blob' });
  return response;
}

export async function verifyDocument(id) {
  const { data } = await client.patch(`/documents/${id}/verify`);
  return data.data;
}

export async function unverifyDocument(id) {
  const { data } = await client.patch(`/documents/${id}/unverify`);
  return data.data;
}

export async function deleteDocument(id) {
  await client.delete(`/documents/${id}`);
}

export async function listDocumentCandidates(params) {
  const { data } = await client.get('/document-candidates', { params });
  return data.data;
}

export async function listCandidateDocuments(candidateId) {
  const { data } = await client.get(`/candidates/${candidateId}/documents`);
  return data.data;
}

export async function listTimelineCandidates(params) {
  const { data } = await client.get('/timeline-candidates', { params });
  return data.data;
}

export async function getCandidateTimeline(candidateId) {
  const { data } = await client.get(`/candidates/${candidateId}/timeline`);
  return data.data;
}

export async function exportCandidateTimeline(candidateId) {
  return client.get(`/candidates/${candidateId}/timeline/export`, { responseType: 'blob' });
}
